import React from 'react';
import '../Assignments/Assignment.less';
import { apiBatchRequest, apiPost, apiPut, apiRequest, getSpsAPiRequest, spsApiPost, uploadSpsAPiRequest, uploadSpsMetadataAPiRequest } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import { ShowToast, toastType } from '../../utils/toast-service';
import FormGenerator from '../common/FormGenerator';
import { getSectionAttributeValueByKey, UpdateFieldsWithConfiguration } from '../../utils/helper';
import { controlType } from '../../constants/common';
import { getSPSTokenData, Operators, setSPSToken } from '../../constants/appConstants';
import { AppBar, Dialog, IconButton, Paper, Toolbar, Typography } from '@material-ui/core';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { getSharePointUrl } from '../../constants/sharepointApi';
import store from '../../store/appStore';
import _ from 'lodash';
class AssignmentViewUpdate extends React.PureComponent {
  // Constructor to define initial state of the component
  constructor (props) {
    super(props);
    this.state = {
      assignmentData: undefined,
      MarketMasterData: undefined,
      DepartmentMasterData: undefined,
      validationMessages: [],
      filesToBeUploaded: [],
      actionType: undefined,
      approvalStatusId: undefined
    };
  }

  // Get API data before component is mounted
  componentDidMount () {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Assignments.GetAssignmentDetails,
        key: 'assignmentData',
        params: { assignmentId: this.props.selectedAssignmentID }
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'MarketMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'DepartmentMasterData',
        fromCache: true,
        duration: 15
      }, {
        url: API_URL.Transition.GetCustomerListingData,
        key: 'customerMasterData'
      },
      {
        url: API_URL.Assignments.GetServiceTypeMasterData,
        key: 'serviceTypeMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Property.GetPropertyTypeMasterData,
        key: 'propertyTypeMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Transition.GetClientListingData,
        key: 'clientListingData'
      }
    ])
      .then(({
        assignmentData,
        MarketMasterData, DepartmentMasterData,
        customerMasterData, serviceTypeMasterData,
        propertyTypeMasterData,
        clientListingData
      }) => {
        if (assignmentData.success === true) {
          const approvalStatusId = assignmentData.data.map(x => {
            if (x.dbColumn === 'ApprovalStatusId') return x.attributeValue;
          }).filter(x => x !== undefined)[0];
          // console.log(approvalStatusId, this.props.actionType);
          this.setState({
            assignmentData: assignmentData.data,
            AllocationData: assignmentData.data || [],
            configuration: assignmentData.config,
            DepartmentMasterData: DepartmentMasterData.data || [],
            MarketMasterData: MarketMasterData.data || [],
            customerMasterData: customerMasterData.data || [],
            serviceTypeMasterData: serviceTypeMasterData.data || [],
            propertyTypeMasterData: propertyTypeMasterData.data || [],
            clientListingData: clientListingData.data || [],
            approvalStatusId: approvalStatusId
          }, () => {
            if (this.props.selectedAssignmentID) {
              this.getSpsData();
            }
          });
        } else {
          ShowToast('', toastType.ERROR, 5000, 500, 'Server error');
        }
      })
      .catch(() => {
        this._asyncRequest = null;
        ShowToast('', toastType.ERROR, 5000, 500, 'Server error');
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Handle Back button click event to navigate to Main page
  back = () => {
    this.props.goBack();
  }

  // Get Clean name by removing special characters, spaces etc.
  cleanName = (name) => {
    // console.log(name);
    if (name === undefined) {
      return;
    }
    name = name?.replace(/\s+/gi, '-'); // Replace white space with dash
    return name?.replace(/[^a-zA-Z0-9]/gi, ''); // Strip any special charactere
  };

  // Get sharepoint data
  getSpsData = () => {
    if (getSPSTokenData()) {
      this.setState({ spsData: {} });
      const assignmentName = getSectionAttributeValueByKey(this.state.assignmentData, 'assignmentName', false);
      const folderName = this.cleanName(assignmentName);

      getSpsAPiRequest(getSharePointUrl('streamrealty', 'getFolder', '', folderName)).then((res) => {
        // console.log(res);
        if (res !== null && (res.displayName === folderName || res.name === folderName)) {
          const folder = res;
          const driveId = folder.parentReference.driveId;
          const key = folder.id;
          this.setState({ folderName: folderName, spListkey: key });
          if (this.state.filesToBeUploaded && this.state.filesToBeUploaded.length > 0) {
            this.uploadFilesToSharePoint();
          }
          getSpsAPiRequest(getSharePointUrl('streamrealty', 'getChildItem', key, '', driveId)).then((files) => {
            // console.log(files);
            this.setCategoryWiseData(files);
          });
        } else {
          if ((folderName || '').length > 0) {
            spsApiPost({
              url: getSharePointUrl('streamrealty', 'createFolder'),
              postBody: {
                displayName: folderName,
                columns: [
                  {
                    name: 'FileType',
                    text: {}
                  },
                  {
                    name: 'UserEmail',
                    text: {}
                  },
                  {
                    name: 'UserEmail',
                    text: {}
                  }
                ],
                list: {
                  template: 'documentLibrary'
                }
              }
            }).then((data) => {
              if (data) {
                this.getSpsData();
              }
            });
          }
        }
      });
    } else {
      apiRequest({ url: API_URL.Users.AcquireSPToken }).then(({ updateData }) => {
        if (updateData) {
          setSPSToken(updateData);
          this.getSpsData();
        }
      });
    }
  }

  // set documents by categories
  setCategoryWiseData = (spsDataRes) => {
    if (!spsDataRes) return;
    const { value } = _.cloneDeep(spsDataRes);
    const spsCategories = {
      ChangeInOwnerShip: [],
      NewAssignment: [],
      Termination: [],
      OtherDocs: []
    };
    const categoriesKeysList = Object.keys(spsCategories);
    value && value.forEach(obj => {
      const catKeyByName =
        categoriesKeysList.indexOf(obj.name.split('_')[1]) !== -1
          ? obj.name.split('_')[1]
          : '';
      const caseKey =
        (obj.listItem.fields.FileType || '') || catKeyByName;
      switch (caseKey) {
        case 'NewAssignment':
          spsCategories[caseKey].push(obj);
          break;
        case 'ChangeInOwnerShip':
          spsCategories[caseKey].push(obj);
          break;
        case 'Termination':
          spsCategories[caseKey].push(obj);
          break;
        default:
          spsCategories.OtherDocs.push(obj);
          break;
      }
    });
    this.setState({ spsData: spsCategories, spsAllData: spsDataRes, reloadPtf: !this.state.reloadPtf });
  }

  // Get uploaded file
  getUploadedFile = (file, category) => {
    let { filesToBeUploaded } = this.state || [];
    filesToBeUploaded = (filesToBeUploaded || []).filter(x => x.category !== category) || [];
    filesToBeUploaded.push({ category: category, file: file });
    this.setState({ filesToBeUploaded, reloadPtf: !this.state.reloadPtf });
  }

  // Upload selected file on SharePoint
  uploadFilesToSharePoint () {
    this.state.filesToBeUploaded.forEach(x => {
      spsApiPost({
        url: getSharePointUrl(
          'streamrealty',
          'uploadFileSession',
          this.state.spListkey,
          x.category + '_Document_' + this.cleanName(getSectionAttributeValueByKey(this.state.assignmentData, 'assignmentStartDate')) + '.pdf'
        ),
        postBody: {
          fileSize: x.file.size,
          item: {
            '@microsoft.graph.conflictBehavior': 'replace'
          }
        }
      }).then((data) => {
        if (data) {
          uploadSpsAPiRequest(
            data.data.uploadUrl,
            x.file,
            true
          ).then((data) => {
            if (data) {
              ShowToast('File uploaded successfully.', toastType.SUCCESS);
              this.getList(data.name,
                (((store.getState() || {}).auth || {}).account || {}).username || '', x);
              this.back();
            }

            this.back();
          });
        }
      });
    });
  }

  // Get list of Documents on Sharepoint directory
  getList = (fileName, emailId, x) => {
    getSpsAPiRequest(
      getSharePointUrl(
        'streamrealty',
        'getSps',
        this.state.spListkey
      )
    ).then((spsDataRes) => {
      if (spsDataRes) {
        const { value } = spsDataRes;
        for (let i = 0; i < value.length; i++) {
          if (fileName === value[i].name) {
            this.updateMetaData(value[i].listItem.id, emailId, x.category);
            break;
          }
        }
      }
    });
  };

  // Update metadata of files
  updateMetaData = (itemId, emailId = '', category) => {
    const metadata = {
      FileType: category,
      UserEmail: emailId
    };

    uploadSpsMetadataAPiRequest(
      getSharePointUrl(
        'streamrealty',
        'uploadMetadata',
        this.state.spListkey,
        itemId
      ),
      metadata
    ).then(() => {
      // this.setState({ filesToUpload: [], selectedFile: [] });
      // this.getSpsData();
    });
  };

  // Save record
  saveChanges = (param) => {
    if (this.props.actionType === 'Edit') {
      const assignmentID = param.filter((x) => x.dbColumn === 'AssignmentId');
      param.map((value) => {
        if (value.dbColumn === 'ApprovalStatusId') {
          value.attributeValue = 3;
        }
        if (value.dbColumn === 'DocumentName') {
          value.attributeValue = value.category + '_Document_' + this.cleanName(getSectionAttributeValueByKey(param, 'assignmentStartDate')) + '.pdf';
        }
      });
      apiPut(API_URL.Assignments.UpdateAssignment, param, { assignmentId: assignmentID[0].attributeValue }).then(({ data: response }) => {
        if (response.success === true) {
          if (this.state.filesToBeUploaded && this.state.filesToBeUploaded.length > 0) {
            this.getSpsData();
          }
          ShowToast('Record updated successfully.', toastType.SUCCESS, 5000, 500);
        }
      });
      if (!(this.state.filesToBeUploaded && this.state.filesToBeUploaded.length > 0)) {
        this.back();
      }
    } else {
      const marketName = getSectionAttributeValueByKey(param, 'MarketName');

      const serviceType = getSectionAttributeValueByKey(param, 'ServiceType');
      const serviceTypeID = [];
      if (serviceType !== '' && serviceType !== null) {
        const serviceTypeName = serviceType.split('|');

        for (let i = 0; i < serviceTypeName.length; i++) {
          serviceTypeID.push(((this.props.serviceTypeMasterData || []).find((x) => x.serviceType === serviceTypeName[i]) || {}).serviceTypeId);
        }
      }

      param.map((value) => {
        if (value.dbColumn === 'MarketId') {
          value.attributeValue = '' + ((this.props.marketMasterData || []).find(x => x.marketName === marketName) || {}).marketId + '';
        }
        if (value.dbColumn === 'ServiceTypeId') {
          value.attributeValue = '' + serviceTypeID.join('|');
        }
        if (value.dbColumn === 'StatusId') {
          value.attributeValue = '1';
        }
        if (value.dbColumn === 'ApprovalStatusId') {
          value.attributeValue = 3;
        }
        if (value.dbColumn === 'DocumentName') {
          value.attributeValue = value.category + '_Document_' + this.cleanName(getSectionAttributeValueByKey(param, 'assignmentStartDate')) + '.pdf';
        }
      });

      apiPost({
        url: API_URL.Assignments.InsertAssignment,
        params: {},
        postBody: param
      }).then(({ data: response }) => {
        if (response.success === true) {
          if (this.state.filesToBeUploaded && this.state.filesToBeUploaded.length > 0) {
            this.getSpsData();
          }
          ShowToast('Record created successfully.', toastType.SUCCESS, 5000, 500);
        }
      });
      if (!(this.state.filesToBeUploaded && this.state.filesToBeUploaded.length > 0)) {
        this.back();
      }
    }
  };

  // Convert file into blob
  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  // Read file data into Base64
  getBase64Content = (file, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  // View selected file
  viewFileData = async (obj, title) => {
    let url = '';
    if (obj.uploadToSp) {
      const { filesToBeUploaded, spsData } = this.state;
      const file = (filesToBeUploaded || []).find(x => x.category === obj.category);
      if (file && file.file) {
        this.getBase64Content(file.file, (result) => {
          // console.log(result);
          url = result;
          this.showFile(url, title);
        });
      } else if (spsData && spsData[obj.category] && spsData[obj.category].length > 0) {
        const spFile = _.orderBy((spsData[obj.category].filter(x => x.name === title) || []), ['createdDateTime'], ['desc']);
        if (spFile && spFile[0]) {
          this.showFile(await this.getSpBlob(spFile[0]['@microsoft.graph.downloadUrl']), title, true);

          // this.generateShareLinkAndShow(spFile);
        } else {
          ShowToast('File not found!', toastType.INFO, 2000, 2000);
        }
      } else {
        ShowToast('File not found!', toastType.INFO, 2000, 2000);
      }
    } else {
      url = getSectionAttributeValueByKey(this.state.assignmentData, obj.contentKey);
      this.showFile(url, title);
    }
  };

  // Get sharepoint file in Blob
  getSpBlob = (url) => {
    return new Promise(function (resolve, reject) {
      fetch(url)
        .then(response => response.blob())
        .then(function (blob) {
          const dataUrl = URL.createObjectURL(blob);
          return resolve(dataUrl);
        }).catch(() => {
          return resolve('');
        }
        );
    });
  }

  // Show file in file viewer
  showFile = (url, title, isSpsFile = false) => {
    const contentType = 'application/pdf';
    let blobUrl;
    if (isSpsFile === false) {
      const blob = this.b64toBlob(url?.replace('data:application/pdf;base64,', ''), contentType);
      blobUrl = URL.createObjectURL(blob);
    } else {
      blobUrl = url;
    }
    this.setState({
      openaddform: true,
      addformtitle: title,
      addNewformComponent: (
        <div style={{ width: '800px', height: '530px', overflow: 'hidden' }}>
          {/* <iframe src={url} width="700" height="700"></iframe> */}
          {/* <embed src={`data:application/pdf;base64,${url}`} type="application/pdf" width="100%"></embed> */}
          <iframe
            id="iframe"
            onLoad={(ev) => {
              const x = document.getElementById('iframe');
              (((x.contentWindow || {}).document.getElementsByTagName('embed') || [])[0] || {})
                .style.height = '500px';
            }}
            src={blobUrl}
            style={{
              width: '100%',
              height: '100%',
              overflow: 'hidden',
              display: 'block'
            }}
            frameBorder="0"
            allowFullScreen={true}
          ></iframe>
        </div>
      )
    });
  }

  // Update fields on Form
  UpdateFormFields = (val, sourceIdField, isMultiple, formFieldsObj) => {
    this.setState({
      assignmentData: formFieldsObj,
      reloadForm: !this.state.reloadForm
    });
  }

  // Render components based on conditions
  render () {
    const {
      assignmentData,
      MarketMasterData,
      DepartmentMasterData,
      validationMessages,
      customerMasterData,
      serviceTypeMasterData,
      propertyTypeMasterData,
      clientListingData
    } = this.state;
    // const ServiceTypeMasterData = this.props.serviceTypeMasterData;

    const dropDownSource = [
      {
        key: 'marketName',
        option: 'marketName',
        idField: 'marketId',
        source: MarketMasterData
      },
      {
        key: 'propertyType',
        option: 'propertyTypeName',
        idField: 'propertyTypeId',
        source: propertyTypeMasterData
      },
      {
        key: 'serviceType',
        option: 'serviceType',
        idField: 'serviceTypeId',
        source: serviceTypeMasterData
      }, {
        key: 'customerName',
        option: 'customerName',
        idField: 'customerId',
        source: customerMasterData
        // onChange: this.getSelectedTransitionDetails
      },
      {
        key: 'clientName',
        option: 'clientName',
        idField: 'clientId',
        source: clientListingData
      }

    ];
    const DetailsFormConfig = [
      {
        key: 'assignmentName',
        type: controlType.TextBox
      },
      {
        key: 'documentName',
        type: controlType.File,
        contentKey: 'documentContent',
        multiple: false,
        viewFile: true,
        uploadToSp: true,
        onChange: this.UpdateFormFields,
        category: 'NewAssignment'
      },
      {
        key: 'ChangeOfOwnershipDocumentName',
        type: controlType.File,
        contentKey: 'ChangeOfOwnershipDocumentContent',
        multiple: false,
        viewFile: true,
        uploadToSp: true,
        category: 'ChangeInOwnerShip'
      },
      {
        key: 'TerminationDocumentName',
        type: controlType.File,
        contentKey: 'TerminationDocumentContent',
        multiple: false,
        viewFile: true,
        uploadToSp: true,
        category: 'Termination'
      },
      { key: 'serviceType', type: controlType.DropDown, multiple: true, columnWidth: 8 },
      { key: 'newServiceType', type: controlType.DropDown, multiple: true },
      { key: 'clientName', type: controlType.DropDown, multiple: false },
      {
        key: 'propertyName',
        type: controlType.DropDown,
        multiple: true,
        columnWidth: 12
      },
      // { key: 'propertyType', type: controlType.DropDown, multiple: false, columnWidth: 4 },
      { key: 'propertyType', type: controlType.DropDown, multiple: false, columnWidth: 4 },
      { key: 'transitionType', type: controlType.DropDown, multiple: false },
      {
        key: 'marketName',
        type: controlType.DropDown
      },
      { key: 'customerName', type: controlType.DropDown, multiple: false },
      { key: 'newClient', type: controlType.DropDown, multiple: false },
      // { key: 'typeName', type: controlType.DropDown, multiple: false },
      {
        key: 'assignmentStartDate',
        rules: {
          And: [
            {
              operator: Operators.LessThan,
              key: 'assignmentEndDate'
            }
          ]
        }
      },
      {
        key: 'assignmentEndDate',
        rules: {
          And: [
            {
              operator: Operators.GreaterThan,
              key: 'assignmentStartDate'
            }
          ]
        }
      },
      {
        key: 'ManagementPropertyName',
        type: controlType.DropDown,
        multiple: false,
        columnWidth: 8
      },
      {
        key: 'newManagementPropertyName',
        type: controlType.DropDown,
        multiple: false,
        columnWidth: 8
      },
      {
        key: 'ApplyToAll',
        type: controlType.Switch,
        multiple: false,
        columnWidth: 3
      },
      {
        key: 'Description',
        type: controlType.TextBox,
        // columnWidth: 3,
        shrink: this.props.actionType === 'Edit'
      },
      {
        key: 'AssignmentTransitionDetail',
        type: controlType.Table,
        columnWidth: 12,
        shrink: this.props.actionType === 'Edit'
      }
      
    ];
    return (
      <>
        {/* <div className="row table-list-container">
          <Typography variant="h6" gutterBottom>
            {this.props.viewTitle}
          </Typography>
        </div> */}
        <div className="row table-list-container">
          {assignmentData && (
            <FormGenerator
              gridColumn={4}
              formFields={UpdateFieldsWithConfiguration(assignmentData, DetailsFormConfig)}
              dropDownSource={dropDownSource}
              validationMessages={validationMessages}
              saveChanges={this.saveChanges}
              viewPDF={this.viewFileData}
              ReloadForm={this.state.reloadForm}
              getUploadedFile={this.getUploadedFile}
              Editable={((this.state.approvalStatusId !== '4' &&
               (getSectionAttributeValueByKey(assignmentData, 'PropertyTransitionId') === '' || 
               getSectionAttributeValueByKey(assignmentData, 'assignmentId') === '')))}
            ></FormGenerator>
          )}
          {this.state.openaddform && (
            <Dialog open={this.state.openaddform} maxWidth="lg">
              <AppBar
                style={{ position: 'relative', backgroundColor: '#002f6c' }}
              >
                <Toolbar>
                  <Typography
                    variant="h6"
                    className="app-header-white"
                    style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                  >
                    {this.state.addformtitle}
                  </Typography>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={() => {
                      this.setState({
                        openaddform: false,
                        addNewformComponent: undefined
                      });
                    }}
                    aria-label="close"
                  >
                    <IoMdCloseCircleOutline />
                  </IconButton>
                </Toolbar>
              </AppBar>
              <div>
                <Paper>{this.state.addNewformComponent}</Paper>
              </div>
            </Dialog>
          )}
        </div>
      </>
    );
  }
}

export default AssignmentViewUpdate;
